import { useEffect } from "react";
import Head from "next/head";
import Image from "next/image";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import MainHeader from "../components/MainHeader";
import MainFooter from "../components/MainFooter";
import DemoForm from "../components/forms/Form";
import FormMini from "../components/forms/FormMini";

import { getCookie } from "cookies-next";

import fonts from "../styles/FontInter.module.css";
import mainTheme from "../components/mainTheme";
import styles from "../styles/Home.module.css";
import ExitModal from "../components/ExitModal";

export default function TemplatePage({ utm }) {
  useEffect(() => {
    dataLayer.push({ event: "optimize.activate" });
  }, []);

  return (
    <ThemeProvider theme={mainTheme}>
      <Head>
        <title>Marketing Automation - Elm Street</title>
        <meta
          name="description"
          content="Meaningful Marketing Automation. Create Connections. Nurture Relationships. Grow Your Pipeline."
        />
        <link rel="icon" href="/favicon.ico" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@weareelmstreet" />
        <meta name="twitter:creator" content="@weareelmstreet" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://elmstreet.com/marketing_automation" />
        <meta property="og:title" content="Marketing Automation - Elm Street" />
        <meta
          property="og:description"
          content="Meaningful Marketing Automation. Create Connections. Nurture Relationships. Grow Your Pipeline."
        />
        <meta property="og:image" content="https://elmstreet.com/og_images/elmstreetog.jpg" />
      </Head>
      <CssBaseline className={fonts} />
      <MainHeader />



      <ExitModal>
      <div style={{padding:"25px"}}>
                <div style={{textAlign:"center", paddingBottom:"10px"}}> <Typography variant="h4" component="h2" style={{ color: "#333666", textAlign: "center", paddingBottom:"10px" }}>Take The 30-Day <br /><span style={{color:"#f69c26"}}>Marketing Challenge!</span></Typography>
                </div>
                <div style={{textAlign:"center", paddingBottom:"10px"}}>A free downloadable guide with Simple steps to elevate your marketing in less than 1-month.
                </div>
                
                  <FormMini buttonText="accept the challenge" successMsg={<div style={{textAlign:"center"}}><Button variant="contained" color="secondary" href="/assets/30daymarketingchallenge.pdf">Download the PDF</Button></div>}
              formName="es2_marketing_challenge" listId="148009" utmOverride="exit_intent" />
                
         </div>
         <div style={{textAlign:"center"}}>
         <Image
                    src="/mcgo.jpg"
                    width="590px"
                    height="242px"
                    alt="30 Day Marketing Challenge FREE Guide"
                   
                  />
                  </div>
     </ExitModal>







      <div
        style={{
          backgroundImage: "url('autobg.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg">
          <Grid container>
            <Grid item md={4} sm={12}>
              <div
                style={{
                  color: "#FFFFFF",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  height: "400px",
                }}
              >
                <div>
                  <Typography variant="h2" component="h1">
                    <span style={{ color: mainTheme.palette.secondary.main }}>meaningful</span> marketing automation
                  </Typography>
                  <p>Create Connections. Nurture Relationships. Grow Your Pipeline.</p>
                  <Button variant="contained" color="secondary" href="#form">
                    take a tour
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <Container maxWidth="lg" style={{ paddingLeft: "20px", paddingRight: "20px" }}>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
          }}
        >
          <div
            style={{
              marginTop: "70px",
              textAlign: "center",
            }}
          >
            <Grid container spacing={8}>
              <Grid item md={12} sm={12}>
                <Typography variant="h4" component="h4">
                  <span style={{ color: "#f69c26" }}>your time </span>is precious
                </Typography>
                Finding the hours to create and deliver meaningful content across email, social media, your website
                blog...well, it's overwhelming. But, it doesn't have to be. Imagine how much time you can free up when
                it's all done for you...automatically.
              </Grid>
            </Grid>
          </div>
        </Container>
      </Container>

      <div>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "25px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={4} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h4">
                  <span style={{ color: "#f69c26" }}>
                    email
                    <br />
                  </span>{" "}
                  marketing
                </Typography>
                <br />
                <span>
                  Offering gorgeous email templates for the DIY'ers, customizable drip campaigns, monthly e-newsletters,
                  and automated daily market reports…you've never met a more robust solution for connecting with clients
                  and prospects through their inbox.
                  <div style={{ paddingTop: "20px" }}>
                    <Button variant="contained" color="secondary" href="#form">
                      schedule demo
                    </Button>
                  </div>
                </span>
              </Grid>
              <Grid item md={8} sm={12} style={{ marginBottom: "-6px" }}>
                <div>
                  <Image
                    src="/ma1.gif"
                    width="1346px"
                    height="887px"
                    unoptimized={true}
                    alt="Elm Street Marketing Automation - Email Marketing"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div style={{ backgroundColor: "#f7f7f7" }}>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "35px",
            paddingBottom: "65px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={6} sm={12}>
                <div>
                  <Image
                    src="/social2.png"
                    width="745px"
                    height="600px"
                    alt="Elm Street Marketing Automation - Social Media"
                  />
                </div>
              </Grid>
              <Grid item md={6} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h4">
                  <span style={{ color: "#f69c26" }}>social</span>
                  <br />
                  media
                </Typography>
                <br />
                <span>
                  Turn your social media from a toy into a powerful marketing tool. Automate your listings to Facebook,
                  Twitter, LinkedIn, and YouTube. Deliver relevant lifestyle content across social, linking back to your
                  website. All branded to YOU.
                  <div style={{ paddingTop: "20px" }}>
                    <Button variant="contained" color="secondary" href="#form">
                      learn more
                    </Button>
                  </div>
                </span>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "25px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={4} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h4">
                  <span style={{ color: "#f69c26" }}>
                    blog
                    <br />
                  </span>{" "}
                  content
                </Typography>
                <br />
                <span>
                  Build SEO-value, showcase your listings, and deliver engaging content to your audience…automatically.
                  Elm Street's Content Team creates and automates content on your behalf with a focus on building
                  following, increasing engagement, and keeping you top-of-mind.
                  <div style={{ paddingTop: "20px" }}>
                    <Button variant="contained" color="secondary" href="#form">
                      take a tour
                    </Button>
                  </div>
                </span>
              </Grid>
              <Grid item md={8} sm={12} style={{ marginBottom: "-6px" }}>
                <div>
                  <Image
                    src="/ma3.png"
                    width="1281px"
                    height="997px"
                    alt="Elm Street Marketing Automation - Blog Content"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div
        style={{
          backgroundImage: "url('happybg.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg">
          <Grid container>
            <Grid item md={4} sm={12}>
              <div
                style={{
                  color: "#FFFFFF",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  height: "500px",
                }}
                alt="Elm Street Marketing Automation - Text"
              >
                <div>
                  <Typography variant="h4" component="h4">
                    <span style={{ color: mainTheme.palette.secondary.main }}>text</span>
                  </Typography>
                  <p>
                    Take your lead follow-up to the next level with Elm Street's Concierge that engages your leads via
                    text, email, AND phone over the course of 1-year. We'll let you know when your leads are ready for a
                    conversation.
                    <br />
                    <br />
                    <Button variant="contained" color="secondary" href="#form">
                      explore concierge
                    </Button>
                  </p>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <div
        style={{
          backgroundImage: "url('orangebg.webp')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg" style={{ paddingTop: "80px", paddingBottom: "85px" }}>
          <div style={{}}>
            <a id="form" />
            <Typography variant="h4" component="h4" style={{ color: "#1d1746", textAlign: "center" }}>
              schedule a demo
            </Typography>
            <div style={{ paddingBottom: "40px", textAlign: "center" }}>
              <strong style={{ color: "#1d1746" }}>What can you do with your extra time? Let’s find out!</strong>
            </div>
            <div style={{ padding: "40px", backgroundColor: "#ffffff" }}>
              <Container
                maxWidth="lg"
                style={{
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  marginTop: "65px",
                  marginBottom: "65px",
                }}
              >
                <Grid container>
                  <Grid item md={2} sm={12} xs={12} />
                  <Grid item md={8} sm={12} xs={12}>
                    <DemoForm
                      buttonText="Schedule Demo"
                      listId="147988"
                      formName="es2_marketing_automation"
                      successUrl="thankyou"
                      fieldList={["first_name", "last_name", "email", "phone", "roll"]}
                    />
                  </Grid>
                </Grid>
              </Container>
            </div>
          </div>
        </Container>
      </div>

      <MainFooter />
    </ThemeProvider>
  );
}

export const getServerSideProps = ({ req, res }) => {
  let cookies = getCookie("elmlead", { req, res });
  if (cookies) {
    return { props: { utm: cookies } };
  }
  return { props: {} };
};
